<template>
  <div class='DashBoard'>
    <div class='cabecalho'>
      <div class='tituloPagina'>Visão geral</div>
      <div class='filtros'>
        <span>Período: <b>Hoje</b></span>
        <span>Comparar com: <b>Ontem</b></span>
      </div>
    </div>
    <div class='grid'>
      <div class='card indicadores'>
        <CardIndicador
          v-for='(item, i) in indicadores'
          :key='i'
          :label='item.label'
          :valor='item.valor'
          :porcentagem='item.porcentagem'
        />
      </div>
      <div class='card resumos'>
        <CardResumo
          v-for='(item, i) in resumos'
          :key='i'
          :label='item.label'
          :valor='item.valor'
        />
      </div>
      <div class='card produtosReceita'>
        <div class='titulo'>Produtos com maior receita</div>
        <div class='lista'>
          <CardProdutoReceita
            v-for='(item, i) in produtosReceita'
            :key='i'
            :imagem='item.imagem'
            :descricao='item.descricao'
            :valorReceita='item.valorReceita'
          />
        </div>
      </div>
      <div class='card funil'>
        <div class='titulo'>
          Funil de vendas
          <span class='subtitulo'>Somente loja online</span>
        </div>
        <div class='etapas'>
          <CardFunil
            v-for='(item, i) in funil'
            :key='i'
            :label='item.label'
            :sessoes='item.sessoes'
            :porcentagem='item.porcentagem'
            :variacao='item.variacao'
          />
        </div>
      </div>
      <div class='card mensal'>
        <div class='titulo'>
          {{ mensal.metrica === 'faturamento' ? 'Faturamento mensal (R$)' : 'Pedidos mensais' }}
          <div class='seletor'>
            <button :class='{ ativo: mensal.metrica === "faturamento" }' @click='mensal.metrica = "faturamento"'>Faturamento</button>
            <button :class='{ ativo: mensal.metrica === "pedidos" }' @click='mensal.metrica = "pedidos"'>Pedidos</button>
          </div>
        </div>
        <GraficoLinha :labels='mensal.meses.map(m => m.mes)' :series='mensalSeries' />
      </div>
      <div class='card tendencias'>
        <div class='titulo'>Análise das tendências de pedidos</div>
        <GraficoLinha
          :labels='tendencias.labels'
          :series='tendencias.series'
        />
      </div>
    </div>
    <!-- <iframe
    :src="'/dashboard/dash/template/DashCR.html?_id='+Empresa._id"
    width="100%" 
    height="100%"
    frameborder="0">
    </iframe> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardIndicador from './CardIndicador.vue'
import CardResumo from './CardResumo.vue'
import CardProdutoReceita from './CardProdutoReceita.vue'
import CardFunil from './CardFunil.vue'
import GraficoLinha from './GraficoLinha.vue'
import api from '@/mixins/api'
export default {
  name: 'DashBoard',
  mixins: [api],
  components: { CardIndicador, CardResumo, CardProdutoReceita, CardFunil, GraficoLinha },
  data () {
    return {
      indicadores: [
        { label: 'Receita', valor: 'R$ 0,00', porcentagem: 0 },
        { label: 'Ticket médio', valor: 'R$ 0,00', porcentagem: 0 },
        { label: 'Pedidos', valor: 0, porcentagem: 0 },
        { label: 'Sessões', valor: 0, porcentagem: 0 }
      ],
      resumos: [
        { label: 'Produtos populares sem estoque', valor: 0 },
        { label: 'Pedidos com pagamento em autorização', valor: 0 },
        { label: 'Pedidos na última hora', valor: 0 }
      ],
      produtosReceita: [],
      //chave = grupo de rotas da GetAcessos
      funil: [
        { chave: 'total', label: 'Total de sessões', sessoes: 0, porcentagem: 0, variacao: null },
        { chave: 'produtos', label: 'Sessões na loja', sessoes: 0, porcentagem: 0, variacao: null },
        { chave: 'categorias', label: 'Sessões de categoria', sessoes: 0, porcentagem: 0, variacao: null },
        { chave: 'carrinho', label: 'Sessões de carrinho', sessoes: 0, porcentagem: 0, variacao: null },
        { chave: 'pagamento', label: 'Sessões de pagamento', sessoes: 0, porcentagem: 0, variacao: null },
        { chave: 'pedidos', label: 'Sessões de pedidos', sessoes: 0, porcentagem: 0, variacao: null }
      ],
      mensal: {
        metrica: 'faturamento',
        meses: []
      },
      tendencias: {
        labels: [],
        series: [
          { nome: 'Hoje', cor: '#3b6bb5', pontos: true, valores: [] },
          { nome: 'Ontem', cor: '#c4c4c4', pontos: false, valores: [] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['Empresa']),
    //ano atual x ano anterior da métrica selecionada (meses que ainda não chegaram vêm null e não são desenhados)
    mensalSeries () {
      const ano = new Date().getFullYear()
      const campo = this.mensal.metrica
      return [
        { nome: String(ano), cor: '#3b6bb5', pontos: true, valores: this.mensal.meses.map(m => m[`${campo}Atual`]) },
        { nome: String(ano - 1), cor: '#c4c4c4', pontos: false, valores: this.mensal.meses.map(m => m[`${campo}Anterior`]) }
      ]
    }
  },
  methods: {
    ...mapActions(['GetIndicadores', 'GetProdsReceita', 'GetPedidosHora', 'GetFaturamentoPedidosMensal', 'GetResumos', 'GetAcessos'])
  },
  mounted () {
    const moeda = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    this.GetIndicadores().then(({ faturamento, ticketMedio, pedidos, sessoes }) => {
      //variação null (dia anterior zerado) aparece como 0%
      this.indicadores[0].valor = moeda(faturamento.valor)
      this.indicadores[0].porcentagem = faturamento.variacao || 0
      this.indicadores[1].valor = moeda(ticketMedio.valor)
      this.indicadores[1].porcentagem = ticketMedio.variacao || 0
      this.indicadores[2].valor = pedidos.valor
      this.indicadores[2].porcentagem = pedidos.variacao || 0
      this.indicadores[3].valor = sessoes.valor
      this.indicadores[3].porcentagem = sessoes.variacao || 0
    })
    this.GetProdsReceita().then(prods => {
      //img é o caminho relativo no servidor da API
      this.produtosReceita = prods.map(p => ({
        imagem: p.img ? this.api + p.img : '',
        descricao: p.descricao,
        valorReceita: p.receita
      }))
    })
    this.GetPedidosHora().then(horas => {
      //hoje vem null nas horas que ainda não chegaram, e o gráfico não desenha esses pontos
      this.tendencias.labels = horas.map(h => h.hora)
      this.tendencias.series[0].valores = horas.map(h => h.hoje)
      this.tendencias.series[1].valores = horas.map(h => h.ontem)
    })
    this.GetFaturamentoPedidosMensal().then(meses => {
      this.mensal.meses = meses
    })
    this.GetResumos().then(({ prodsSemEstoque, pedidosPendentes, pedidosUltimaHora }) => {
      this.resumos[0].valor = prodsSemEstoque
      this.resumos[1].valor = pedidosPendentes
      this.resumos[2].valor = pedidosUltimaHora
    })
    this.GetAcessos().then(acessos => {
      //porcentagem = participação de cada grupo no total de sessões do dia
      const total = acessos.total.valor
      this.funil.forEach(etapa => {
        const { valor, variacao } = acessos[etapa.chave]
        etapa.sessoes = valor
        etapa.porcentagem = total ? Number((valor / total * 100).toFixed(2)) : 0
        etapa.variacao = variacao
      })
    })
  }
}
</script>

<style scoped>
.DashBoard {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 16px;
  box-sizing: border-box;
  color: #303030;
}
.cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.tituloPagina {
  font-size: 16px;
  font-weight: 600;
}
.filtros {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #616161;
}
.filtros b {
  color: #303030;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 240px;
  grid-template-areas:
    'indicadores indicadores resumos'
    'tendencias  mensal      produtos'
    'funil       funil       produtos';
  gap: 12px;
}
.card {
  min-width: 0;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  box-sizing: border-box;
}
.card .titulo {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
}
.card .subtitulo {
  margin-left: 16px;
  font-size: 11px;
  font-weight: normal;
  color: #8a8a8a;
}
.indicadores {
  grid-area: indicadores;
  display: flex;
}
.resumos {
  grid-area: resumos;
  display: flex;
}
.tendencias {
  grid-area: tendencias;
  padding: 16px;
}
.mensal {
  grid-area: mensal;
  padding: 16px;
}
.mensal .titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seletor {
  display: flex;
}
.seletor button {
  padding: 2px 10px;
  border: 1px solid #e5e5e5;
  background: #fff;
  font-size: 11px;
  color: #616161;
  cursor: pointer;
}
.seletor button:first-child {
  border-radius: 4px 0 0 4px;
}
.seletor button:last-child {
  border-left: none;
  border-radius: 0 4px 4px 0;
}
.seletor button.ativo {
  background: #3b6bb5;
  border-color: #3b6bb5;
  color: #fff;
}
.funil {
  grid-area: funil;
  padding: 16px;
}
.funil .titulo {
  margin-bottom: 20px;
}
.funil .etapas {
  display: flex;
}
.produtosReceita {
  grid-area: produtos;
  display: flex;
  flex-direction: column;
  padding: 16px;
}
.produtosReceita .titulo {
  margin-bottom: 8px;
}
/* height 0 + flex 1: a lista ocupa a altura das linhas sem esticá-las */
.produtosReceita .lista {
  flex: 1;
  height: 0;
  min-height: 200px;
  overflow-y: auto;
}
@media (max-width: 1100px) {
  .grid {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'indicadores indicadores'
      'resumos     resumos'
      'tendencias  mensal'
      'funil       funil'
      'produtos    produtos';
  }
  .produtosReceita .lista {
    height: auto;
    max-height: 440px;
  }
}
@media (max-width: 700px) {
  .grid {
    grid-template-columns: 1fr;
    grid-template-areas:
      'indicadores'
      'resumos'
      'tendencias'
      'mensal'
      'funil'
      'produtos';
  }
  .indicadores {
    flex-wrap: wrap;
  }
  /* funil em 2 colunas: separador vertical só na coluna da direita e linha entre as fileiras */
  .funil .etapas {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .funil .etapas > :deep(.CardFunil:nth-child(odd)) {
    border-left: none;
  }
  .funil .etapas > :deep(.CardFunil:nth-child(n + 3)) {
    border-top: 1px solid #e5e5e5;
    padding-top: 12px;
  }
}
</style>
